import { render, staticRenderFns } from "./detail_page.vue?vue&type=template&id=3444a864&scoped=true"
import script from "./detail_page.vue?vue&type=script&lang=js"
export * from "./detail_page.vue?vue&type=script&lang=js"
import style0 from "./detail_page.vue?vue&type=style&index=0&id=3444a864&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3444a864",
  null
  
)

export default component.exports